"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var Box_1 = require("../Box");
var Button_1 = require("../Button");
var SorterButton = styled_components_1.default(Button_1.Button)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  flex-shrink: 1;\n  height: 100%;\n"], ["\n  flex-shrink: 1;\n  height: 100%;\n"])));
var Sorter = function (_a) {
    var align = _a.align, children = _a.children, fill = _a.fill, onSort = _a.onSort, property = _a.property, sort = _a.sort, theme = _a.theme, themeProps = _a.themeProps;
    var icon;
    if (sort && sort.property === property) {
        var Icon = theme.dataTable.icons[sort.ascending ? 'ascending' : 'descending'];
        icon = React.createElement(Icon, null);
    }
    var content = (React.createElement(Box_1.Box, tslib_1.__assign({}, themeProps, { flex: "shrink", direction: "row", justify: align, align: "center", gap: "xxsmall", fill: fill }),
        children,
        icon));
    if (onSort) {
        content = (React.createElement(SorterButton, { plain: true, fill: fill, hoverIndicator: true, onClick: onSort(property) }, content));
    }
    return content;
};
var SorterWrapper = recompose_1.compose(styled_components_1.withTheme)(Sorter);
exports.Sorter = SorterWrapper;
var templateObject_1;
//# sourceMappingURL=Sorter.js.map